import axios from "axios";

let baseUrl = 'http://localhost:8080/api/v1'
if(import.meta.env.MODE === 'development')
  baseUrl = 'http://localhost:8080/api/v1'
else if(import.meta.env.MODE === 'test')
  baseUrl = 'https://api.impactus2.co.kr/api/v1'
else if(import.meta.env.MODE === 'prod')
  baseUrl = 'https://api.impactus.co.kr/api/v1'

const instance = axios.create({
  baseURL: baseUrl,
  headers: {
    "Content-Type": "application/json",
  },
  responseType: 'blob'
});

export default instance;
